import React from 'react';
import { Box, Button, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import logo from '../assets/images/transcriber-logo.svg';

export default function PublicHeader() {
    const route = useLocation();
    return (
        <>
            <Box
                component="header"
                sx={{
                    px: { xs: 2, md: 4 },
                    pr: { xs: 2, md: 3 },
                    py: 2,
                    bgcolor: 'rgba(255, 255, 255, 0.8)',
                    position: 'sticky',
                    top: 10,
                    zIndex: 1000,
                    maxWidth: '90%',
                    width: '90%',
                    mx: 'auto',
                    borderRadius: '999px',
                    boxShadow: '0 2px 8px rgba(15, 23, 42, 0.08)',
                    backdropFilter: 'blur(10px)',
                }}
            >
                <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    alignItems="center"
                    justifyContent="space-between"
                    spacing={{ xs: 2, md: 0 }}
                >
                    <Stack direction="row" alignItems="center" spacing={1.5}>
                        <Box
                            component="img"
                            src={logo}
                            alt="VENDX Genie"
                            sx={{ height: 36, width: 'auto', display: 'block' }}
                        />
                    </Stack>

                    <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        alignItems="center"
                        justifyContent="center"
                        spacing={5}
                        sx={{ mt: { xs: 2, md: 0 } }}
                    >
                        <Link
                            component={RouterLink}
                            to="/"
                            underline="none"
                            color="text.primary"
                            sx={{ fontWeight: route.pathname === '/' ? 600 : 400 }}
                        >
                            Home
                        </Link>
                        <Link
                            component={RouterLink}
                            to="/privacy"
                            underline="none"
                            color="text.primary"
                            sx={{ fontWeight: route.pathname === '/privacy' ? 600 : 400 }}
                        >
                            Privacy Policy
                        </Link>
                        <Link
                            component={RouterLink}
                            to="/support"
                            underline="none"
                            color="text.primary"
                            sx={{ fontWeight: route.pathname === '/support' ? 600 : 400 }}
                        >
                            Support
                        </Link>
                    </Stack>
                </Stack>
            </Box>
            <Box sx={{ height: 20 , background: '#ffffff', position:'fixed', top: 0, left: 0, right: 0, zIndex: 999 }} />
        </>
    );
}
